"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HeadingBox = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HeadingBox = exports.HeadingBox = function HeadingBox(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])("headingBox-component", props.className),
    style: props.style
  }, /*#__PURE__*/_react["default"].createElement("h6", {
    className: "narrow"
  }, props.subTitle), /*#__PURE__*/_react["default"].createElement("h2", null, props.title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "tall"
  }, props.text), props.content && /*#__PURE__*/_react["default"].createElement("div", {
    className: "extraContent"
  }, props.content));
};
HeadingBox.Proptypes = {
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  subTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  content: _propTypes["default"].any
};
HeadingBox.defaultProps = {
  className: "",
  style: {},
  subTitle: "",
  title: "",
  text: "",
  content: null
};
var _default = exports["default"] = HeadingBox;